import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { colors } from '@/theme/foundations/colors';
import { DotFlashingLoaderProps } from './DotFlashingLoader.interface';

const dotFlashing = keyframes`
  0% {
    background-color: ${colors['secondary-100']};
  }
  50%, 100% {
    background-color: rgba(19, 17, 34, 0.2);
  }
`;

export const DotFlashingLoader: React.FC<DotFlashingLoaderProps> = ({
  size = '4px',
  spacing = '12px',
  color = colors['secondary-100'],
  ...props
}) => {
  return (
    <Box
      position="relative"
      width={size}
      height={size}
      borderRadius="12px"
      backgroundColor={color}
      animation={`${dotFlashing} 1s infinite linear alternate`}
      animationDelay="0.5s"
      _before={{
        content: '""',
        display: 'inline-block',
        position: 'absolute',
        top: 0,
        left: `-${spacing}`,
        width: size,
        height: size,
        borderRadius: '12px',
        backgroundColor: color,
        animation: `${dotFlashing} 1s infinite alternate`,
        animationDelay: '0s',
      }}
      _after={{
        content: '""',
        display: 'inline-block',
        position: 'absolute',
        top: 0,
        left: spacing,
        width: size,
        height: size,
        borderRadius: '12px',
        backgroundColor: color,
        animation: `${dotFlashing} 1s infinite alternate`,
        animationDelay: '1s',
      }}
      {...props}
    />
  );
};
